import axios from 'axios'
import Conf from 'ui-config'
//Conf.HOST_S + Conf.LC_IP +
const SignalCasesService = {
  getSignalList: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/signals/list', params, {
      headers: { SSID: ssid },
    })
  },
  getGraphDataforSignals: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/signals/graph_data', params, {
      headers: { SSID: ssid },
    })
  },
  getSignalTimeline: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/signals/timeslice_data', params, {
      headers: { SSID: ssid },
    })
  },
  getUsersList: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/users/list', params, {
      headers: { SSID: ssid },
    })
  },
  getallCaseslist: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/list', params, {
      headers: { SSID: ssid },
    })
  },
  getCasesInfo: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/info', params, {
      headers: { SSID: ssid },
    })
  },

  getCasesinEntity: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/case_list', params, {
      headers: { SSID: ssid },
    })
  },

  getcaseList: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/signals/case_list', params, {
      headers: { SSID: ssid, },
    })
  },
  getCasesHostory: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/case_history', params, {
      headers: { SSID: ssid },
    })
  },
  getInvestigateList: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/wb_list', params, {
      headers: { SSID: ssid },
    })
  },

  getCaseStats: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/list_stats', params, {
      headers: { SSID: ssid },
    })
  },
  getallSignalinCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/signal_list', params, {
      headers: { SSID: ssid },
    })
  },
  createCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/create', params, {
      headers: { SSID: ssid },
    })
  },
  changeCaseStatus: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/change_status', params, {
      headers: { SSID: ssid },
    })
  },
  editCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/edit', params, {
      headers: { SSID: ssid },
    })
  },
  assignUsertoCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/assign_user', params, {
      headers: { SSID: ssid },
    })
  },
  addSignaltoCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/add_signal', params, {
      headers: { SSID: ssid },
    })
  },
  getsignalStatistics: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/stats', params, {
      headers: { SSID: ssid },
    })
  },
  getStreamedWorkbooks: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/workbook/detectionwbcount', params, {
      headers: { SSID: ssid },
    })
  },
  getEntitiesList: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/list', params, {
      headers: { SSID: ssid },
    })
  },
  getEntityListinCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/entity_list', params, {
      headers: { SSID: ssid },
    })
  },
  addEntitytoaCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/add_entity', params, {
      headers: { SSID: ssid },
    })
  },
  getDetections: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/get_detection', params, {
      headers: { SSID: ssid },
    })
  },
  getPanelResponders: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/list_responder', params, {
      headers: { SSID: ssid },
    })
  },
  getEntityScore: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/risk_score', params, {
      headers: { SSID: ssid },
    })
  },
  getLookupforEntity: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/lookup', params, {
      headers: { SSID: ssid },
    })
  },
  killChain: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/kill_chain', params, {
      headers: { SSID: ssid },
    })
  },
  riskyUser: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/risky_users', params, {
      headers: { SSID: ssid },
    })
  },
  riskyEntity: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/risky_entities', params, {
      headers: { SSID: ssid },
    })
  },
  addNotetoCase: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/add_note', params, {
      headers: { SSID: ssid },
    })
  },
  listNotes: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/list_notes', params, {
      headers: { SSID: ssid },
    })
  },
  casesListStats: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/case_stats', params, {
      headers: { SSID: ssid },
    })
  },
  getGraphDataforCases: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/cases/get_graph', params, {
      headers: { SSID: ssid },
    })
  },
  UbaMLData: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/models/baseline/get_data', params, {
      headers: { SSID: ssid },
    })
  },
  ExecuteResponse: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/entities/trigger_responder', params, {
      headers: { SSID: ssid },
    })
  },
  getFacetsTakIds: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/signals/facets/task_id', params, {
      headers: { SSID: ssid },
    })
  },
  getFacetResult: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + Conf.PORT_3 + '/' + clusterId + '/api/signals/facets/result', params, {
      headers: { SSID: ssid },
    })
  },
  getsignalSpecificData: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + Conf.PORT_3 + '/' + clusterId + '/api/signals/data', params, {
      headers: { SSID: ssid },
    })
  },
  getSignalKB: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + Conf.PORT_3 + '/' + clusterId + '/api/signals/get_kb', params, {
      headers: { SSID: ssid },
    })
  },
  getCoverage: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + Conf.PORT_3 + '/' + clusterId + '/api/landingpage/coverage', params, {
      headers: { SSID: ssid },
    })
  },
  getwbTriggered: function (params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + Conf.PORT_3 + '/' + clusterId + '/mgmt/core/running_workbooks', params, {
      headers: { SSID: ssid },
    })
  },
}

export default SignalCasesService
